import PickUpCard from "./PickUpCard";

export default PickUpCard;
